import { compose } from "recompose";
import { AnyAction, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import App from "./app";
import { actions as asyncActions } from "async-ops";
import TsInitSdk from "../common_components/thoughtspot-sdk-app-embed/init";
const mapStateToProps = (state) => ({});

TsInitSdk();

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators(
    {
      asyncOperationStart: asyncActions.asyncOperationStart,
    },
    dispatch
  );

const enhance = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(App);
